export enum InternalRoutes {
    MISSING_WALLET = '/missing-wallet',
    MULTIPLE_WALLETS = '/multiple-wallets-detected',
    WALLET_DIFFERENCE = '/wallet-difference',
    SETUP_HARDWARE_WALLET = '/setup-hardware-wallet',
}
